'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getRichMediaState = exports.getRichMediaState = function getRichMediaState(state, ownProps) {
  return state.getIn(['app', 'richMedia']);
};
var getRichMediaContentState = exports.getRichMediaContentState = function getRichMediaContentState(id, richMediaState) {
  return richMediaState.getIn([id, 'contentState']);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/richMediaSelector.js
// module id = 2023
// module chunks = 0